import { useTransition, animated } from 'react-spring';
import { Switch, Route, useLocation, Redirect, useHistory } from 'react-router-dom';
import React from 'react';
import { HomePage } from '../HomePage';
import { CreatePlaylist } from '../CreatePlaylist';
import { SearchForm } from '../SearchForm';

export const RootRouter = () => {
  const location = useLocation();
  const history = useHistory();

  const forwardTransition = {
    from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
  };

  const backwardTransition = {
    from: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    leave: { opacity: 0, transform: 'translate3d(50%,0,0)' },
  };

  const transitions = useTransition(
    location,
    (location: any) => location.pathname,
    history.action === 'PUSH' ? forwardTransition : backwardTransition
  );

  const transitionList = transitions.map(({ item: location, props, key }) => (
    <animated.div key={key} style={props}>
      <Switch location={location}>
        <Route exact path="/">
          <Redirect to="/home" />
        </Route>
        <Route path="/home" component={HomePage} />
        <Route path="/createPlaylist" component={CreatePlaylist} />
        <Route path="/search" component={SearchForm} />
        <Route path="/yourPlaylist" component={SearchForm} />
      </Switch>
    </animated.div>
  ));

  return <React.Fragment>{transitionList}</React.Fragment>;
};
